import { createUseStyles } from "react-jss";
export const useStyles = createUseStyles({
  drawerWrapper: {
    "&.exclusiveCart": {
      fontFamily: "'Brawler', serif!important",
      "&.ant-drawer-content": {
        backgroundColor: "var(--eSecondary)",
        "& .ant-drawer-header": {
          backgroundColor: "var(--eDark)",
          padding: "20px 30px",
          "& .ant-drawer-title": {
            textAlign: "center",
            color: "var(--eTernary)",
            fontSize: "24px",
            fontWeight: "bold",
            lineHeight: "normal",
          },
          "& svg path": {
            fill: "var(--eTernary)",
          },
        },
        "& .ant-drawer-body": {
          padding: "0",
          position: "relative",
          "& .pcCard": {
            padding: "20px",
            "&  .cPImage": {},
            "&  .ant-image": {
              width: "75px",
              height: "75px",
              padding: "10px",
              background: "radial-gradient(transparent, var(--eTernary))",
              borderRadius: "10px",
            },
            "&  .cPImage img": {
              width: "100%",
              borderRadius: "10px",
              height: "100%",
              objectFit: "contain",
            },
            "&  .cpNameAvQty .cpAvQty span": {
              fontWeight: "bold",
            },
            "&  .cpQty": {
              marginLeft: "auto",
              marginRight: "70px",
              "& button": {
                background: "transparent",
                border: "none",
                boxShadow: "none",
                fontSize: "20px",
                color: "var(--ePrimary)",
                "&:hover": {
                  backgroundColor: "transparent!important",
                  color: "unset!important",
                  boxShadow: "none!important",
                },
              },
              "&  .cpQtyNum": {
                border: "1px solid var(--ePrimary)",
                width: "25px",
                height: "25px",
                borderRadius: "5px",
                fontWeight: "bold",
              },
            },
            "&  .cpPrice": {
              width: "110px",
              textAlign: "right",
            },
            "&:not(:first-child)": {
              borderTop: "1px solid var(--ePrimaryO10)",
            },
          },
          "& .emptyBasket": {
            height: "100%",
          },
        },
        "& .ant-drawer-footer": {
          padding: "20px 30px",
        },
      },
    },
    "&.suiFrensCart": {
      "&.ant-drawer-content": {
        backgroundColor: "var(--white)",
        "& .ant-drawer-header": {
          backgroundColor: "var(--sPrimary)",
          padding: "15px 30px",
          "& .ant-drawer-title": {
            textAlign: "center",
            color: "var(--black)",
            fontSize: "24px",
            fontWeight: "400!important",
            lineHeight: "normal",
            fontFamily: '"Frankfurter Std Regular", sans-serif!important',
          },
          "& svg path": {
            fill: "var(--blackOpacity75)",
          },
        },
        "& .ant-drawer-body": {
          padding: "0",
          position: "relative",
          "& .pcCard": {
            padding: "15px 20px",
            "&  .ant-image": {
              width: "75px",
              height: "75px",
              padding: "10px",
              background: "radial-gradient(transparent,var(--light))",
              borderRadius: "5px",
            },
            "&  .cPImage img": {
              width: "100%",
              borderRadius: "10px",
              height: "100%",
              objectFit: "contain",
            },
            "&  .cpNameAvQty": {
              "& .cPName ": {
                textTransform: "capitalize",
                fontFamily: '"Frankfurter Std Regular", sans-serif!important',
              },

              "& .cpAvQty": {
                color: "var(--blackOpacity75)",
                "&  span": {
                  color: "var(--black)",
                  fontWeight: "bold",
                },
              },
            },
            "&  .cpQty": {
              marginLeft: "auto",
              marginRight: "70px",
              padding: "10px 20px",
              borderRadius: "5px",
              border: "1px solid var(--blackOpacity10)",
              display: "flex",
              alignItems: "baseline",
              gap: "15px",
              "& button": {
                background: "transparent",
                border: "none",
                boxShadow: "none",
                fontSize: "20px",
                color: "var(--black)",
                lineHeight: "0",
                padding: "0",
                "&:hover": {
                  backgroundColor: "transparent!important",
                  color: "unset!important",
                  boxShadow: "none!important",
                },
              },
              "& .cpQtyNum ": {
                fontWeight: "bold",
              },
            },
            "&  .cpPrice": {
              width: "110px",
              textAlign: "right",
            },
            "&:not(:first-child)": {
              borderTop: "1px solid var(--ePrimaryO10)",
            },
          },
          "& .emptyBasket": {
            height: "100%",
            "& p": {
              fontFamily: '"Frankfurter Std Regular", sans-serif!important',
            },
          },
        },
        "& .ant-drawer-footer": {
          padding: "15px 30px",
        },
      },
    },
  },
});
